import { render, staticRenderFns } from "./UpdateRouter.vue?vue&type=template&id=37994a7c&"
import script from "./UpdateRouter.vue?vue&type=script&lang=js&"
export * from "./UpdateRouter.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRouter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports